const Path = {
  home: '/',
  error: '/error',
}

export default Path
